(function () {
  'use strict';

  const LoadMoreCollection = {
    button: null,
    loader: null,
    productGrid: null,
    loading: false,
    sectionId: null,

    init: function () {
      this.cacheElements();
      if (!this.productGrid) return;

      this.bindButton();

      // Re-init when filters/sort reload the collection via AjaxRenderer
      document.addEventListener('collection:reloaded', this.onReloaded.bind(this));
    },

    cacheElements: function () {
      this.button = document.querySelector('.load-more-btn');
      this.loader = document.getElementById('infinite-scroll-loader');
      this.productGrid = document.querySelector('#CollectionAjaxContent .grid.grid--uniform');
      const sectionEl = document.querySelector('[data-section-type="collection-grid"]');
      this.sectionId = sectionEl ? sectionEl.dataset.sectionId : null;
    },

    bindButton: function () {
      if (!this.button) return;
      // Use a stable reference so we can detach/re-attach across reloads.
      if (this._onClick) this.button.removeEventListener('click', this._onClick);
      this._onClick = this.loadMore.bind(this);
      this.button.addEventListener('click', this._onClick);
    },

    loadMore: function () {
      if (this.loading || !this.button) return;

      const nextUrl = this.button.dataset.nextUrl;
      if (!nextUrl) return;

      this.loading = true;
      this.setButtonLoading(true);
      this.showLoader();

      // Section-render fetch keeps Liquid context (filters, sort, search) intact.
      const fetchUrl = this.sectionId
        ? nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + this.sectionId
        : nextUrl;

      const self = this;
      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error ' + response.status);
          return response.text();
        })
        .then(function (html) {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');

          // Append the next page's product items.
          const newGrid = newDoc.querySelector('.grid.grid--uniform');
          if (newGrid) {
            const frag = document.createDocumentFragment();
            Array.from(newGrid.children).forEach(function (item) {
              frag.appendChild(item);
            });
            self.productGrid.appendChild(frag);

            if (typeof theme !== 'undefined' && typeof theme.reinitProductGridItem === 'function') {
              theme.reinitProductGridItem();
            }
          }

          // Replace the button's data-next-url so the next click loads the
          // following page, or remove the button entirely when there's no
          // next page left.
          const newButton = newDoc.querySelector('.load-more-btn');
          if (newButton && self.button) {
            self.button.dataset.nextUrl = newButton.dataset.nextUrl;
            self.button.dataset.currentPage = newButton.dataset.currentPage;
          } else if (self.button) {
            self.button.parentNode.removeChild(self.button);
            self.button = null;
          }
        })
        .catch(function (err) {
          console.error('[LoadMore] Failed to load more products:', err);
        })
        .then(function () {
          self.loading = false;
          self.setButtonLoading(false);
          self.hideLoader();
        });
    },

    setButtonLoading: function (isLoading) {
      if (!this.button) return;
      this.button.disabled = isLoading;
      this.button.classList.toggle('is-loading', isLoading);
    },

    showLoader: function () {
      if (this.loader) this.loader.style.display = 'flex';
    },

    hideLoader: function () {
      if (this.loader) this.loader.style.display = 'none';
    },

    onReloaded: function () {
      // After filter/sort, AjaxRenderer replaces #CollectionAjaxContent innerHTML,
      // so the button is a fresh DOM node — re-query and re-bind.
      this.loading = false;
      this.cacheElements();
      this.bindButton();
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    LoadMoreCollection.init();
  });
})();
